import { TableCell, styled } from "@mui/material";

export const StyledTableCell = styled(TableCell)({
  fontSize: 15,
  lineHeight: "20px",
  backgroundColor: "transparent",
  color: "#2A3333",
  border: "none",
  padding: "14px 16px",
  textAlign: "left",
  verticalAlign: "middle",
  whiteSpace: "nowrap",
});
